import catalogArts from '../assets/image/catalog-arts.jpg';
import catalogCharity from '../assets/image/catalog-charity.jpg';
import catalogCulture from '../assets/image/catalog-culture.jpg';
import catalogEntertainment from '../assets/image/catalog-entertainment.jpg';
import catalogFamily from '../assets/image/catalog-family.jpg';
import catalogFood from '../assets/image/catalog-food.jpg';
import catalogMusic from '../assets/image/catalog-music.jpg';
import catalogSports from '../assets/image/catalog-sports.jpg';

/** Parent browse slug → header image for desktop mega menu (see `event-browse-categories.json`). */
const MEGA_MENU_CATEGORY_IMAGE_BY_SLUG = {
  'music-concerts': catalogMusic,
  sports: catalogSports,
  'theatre-arts': catalogArts,
  'comedy-entertainment': catalogEntertainment,
  'family-education': catalogFamily,
  'festivals-community': catalogCulture,
  'food-drink': catalogFood,
  'charity-causes': catalogCharity,
};

export const getMegaMenuCategoryImage = slug => {
  if (slug == null || slug === '') {
    return null;
  }
  return MEGA_MENU_CATEGORY_IMAGE_BY_SLUG[String(slug).toLowerCase()] || null;
};
